<style lang="scss">
.btn { white-space: normal; }
</style>

<template>
    <div>
        <div class="col-md-12">
            <input type="text" v-model="search" class="form-control mb-2" placeholder="Search Product">
        </div>
        <div class="col-md-12">
            <sub class="text-danger">1st</sub>
        </div>
        <div class="col-md-12">
            <div class="row" style="height:800px; overflow-y:auto; overflow-x:hidden; border-style:groove; border-radius:5px;">
                <div class="card card-body col-md-4 border-0" v-for="product in FilterProduct" :key="product.id">

                    <button :class="(product.quantity > 0 ? 'btn btn-primary active btn-sm p-4' : 'btn btn-primary disabled btn-sm p-4')" style="border-radius: 10px" data-toggle="modal" :data-target="'#'+ target + product.id" @click="showModal(product.id)">
                        <div class="row justify-content-center">
                            <strong>{{product.name}}</strong>
                        </div>
                    </button>

                    <div class="modal fade" :id="target + product.id" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="ProductName"><template v-if="Settings.Category === 'Trial'">TRIAL CLASS-{{product.name}}</template><template v-else>{{product.name}}</template></h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="row">

                                                <div v-for="(option, index) in options" v-bind:key="index" class="card card-body col-md-12 m-2">
                                                    <center>
                                                        <h4 v-if="option.item_name !== undefined">{{option.item_name}}</h4>

                                                        <h5> <label v-if="option.venue_name !== undefined"> {{option.venue_name}} - </label> {{option.option_name}} </h5>


                                                        <h5 v-if="option.week_name !== undefined"> ( {{option.week_name}} {{option.start}} - {{option.end}} ) </h5>

                                                        <h5 v-if="option.option_price !== undefined">AED

                                                            <template v-if="Settings.Category === 'Location'">
                                                                <input type="number" v-model="option.option_price" class="form-control" disabled="false" style="width:140px">
                                                            </template>
                                                            <template v-else-if="Settings.Category === 'Service' || Settings.Category === 'Trial'">
                                                                <!-- <template v-if="option.status === 'Adult'">
                                                                    <input type="number" v-model="option.option_price" class="form-control" style="width:140px">
                                                                </template>
                                                                <template v-else>
                                                                    <input type="number" v-model="option.option_price" class="form-control" disabled style="width:140px">
                                                                </template> -->
                                                                <select v-model="option.option_price" style="max-width: 250px;">
                                                                     <option v-for="(item, index) in option.option_prices" :key="option.id + '_' + index + '_' + item.price" :selected="index === 0" :value="item.price"> {{item.price}} -  {{item.serviceName}}</option>
<!--                                                                    <option v-for="(item, index) in option.option_prices" :key="item.price" :selected="index === 0" > {{item.price}} -  {{item.serviceName}} </option>-->
                                                                </select>
                                                            </template>
                                                            <template v-else>
                                                                <input type="number" v-model="option.option_price" class="form-control" disabled="true" style="width:140px">
                                                            </template>
                                                            <!-- <input type="number" v-model="option.option_price" class="form-control" :disabled="Settings.Category === 'Location' ? 'false' : 'true'" style="width:140px"> -->

                                                            <label v-if="option.option_quantity !== undefined"> - Stock(s) {{option.option_quantity}} </label> </h5>

                                                        <div v-if="option.price !== undefined" >
                                                            <input class="form-control" type="number"  v-model='option.price' style="width:120px">
                                                        </div>
                                                    </center>

                                                    <div v-if="option.staticdiscount !== undefined && Settings.Category !== 'Trial'" class="form-group mt-4">
                                                        <label for="ebd"> EBD</label> <input type="radio" v-model='option.staticdiscount' value="ebd" id="ebd" >

                                                        <label for="siblings" class="ml-4"> Siblings</label> <input type="radio" v-model='option.staticdiscount' value="sibling" id="siblings" >

                                                        <!-- <label for="4class"> 4 Classes</label> <input type="radio" v-model='option.staticdiscount' value="class4" id="4class" >

                                                        <label for="5class"> 5 Classes</label> <input type="radio" v-model='option.staticdiscount' value="class5"  id="5class" >

                                                        <label for="6class"> 6 Classes</label> <input type="radio" v-model='option.staticdiscount' value="class6"  id="6class" >

                                                        <label for="7class"> 7 Classes or more</label> <input type="radio" v-model='option.staticdiscount' value="class7" id="7class" > -->

                                                    </div>


                                                    <div v-if="Settings.Category === 'Service' || Settings.Category === 'Trial'">
                                                        <template v-if="option.status === 'Adult'">
                                                            <input type="number" v-model="option.quantity" min="1"  :max="option.option_quantity" class="form-control" style="width:66px" />
                                                        </template>
                                                        <template v-else>
                                                            <input type="number" v-model="option.weeks" min="1" @change="numberWeeks"  :max="option.option_quantity" class="form-control" style="width:66px" />
                                                        </template>
                                                    </div>
                                                    <div v-else>
                                                        <input type="number" v-model="option.quantity" min="1"  :max="option.option_quantity" class="form-control" style="width:66px"/>
                                                    </div>

                                                    <div v-if="option.date !== undefined" >
                                                        <input class="form-control" type="date"  v-model='option.date'>
                                                    </div>

                                                    <input type="text" v-model="option.notes" class="form-control" placeholder="notes">

                                                    <!-- <template v-if="option.staticdiscount == false"> -->
                                                    <model-select :options="discounttype"
                                                                  v-model="option.discountvalue"
                                                                  placeholder="Please select discount">
                                                    </model-select>

                                                    <input v-if="option.discountvalue !== ''" type="number" v-model="option.discount" class="form-control" placeholder="discount" style="width:120px">
                                                    <!-- </template> -->

                                                    <button  @click="addCart(option)" class="btn btn-primary btn-block mt-2">Add to Cart</button>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { ModelSelect } from 'vue-search-select'
export default {
    props:['products', 'target', 'options', 'Settings', 'weeks'],
    components: {ModelSelect},

    data() {
        return {
            search: '',
            discounttype: [
                {value: 'percent', text: 'Percentage'},
                {value: 'fixed', text: 'Fixed'},
            ],
            location: null,
            week: null,
            time: null,
            ind: 0
        }
    },
    methods: {
        showModal(id) {
            return this.$emit('modals', id)
        },
        addCart(id) {
            console.log(id);
            this.$emit('weeks-value', id.weeks)
            return this.$emit('Add-Product', id)
        },
        numberWeeks() {
            return this.$emit('weeks-value', this.weeks)
        }
    },
    computed: {
        FilterProduct: function() {
            // let search = new RegExp(this.search, 'i')
            return this.products.filter((product) => {
                // return product.name.match(this.search)
                return product.name.toLowerCase().includes(this.search)
            })
        }
    }

}
</script>



// WEBPACK FOOTER //
// resources/js/POS/Item.vue